import React from 'react';
import { Clock, User } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-12 pb-12 md:pt-16 md:pb-16" data-id="element-62">
      <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-6 text-gray-900 tracking-tight" data-id="element-63">
        Meer dan 40 keer per dag zegt je hond iets belangrijks. 96% van de
        hondenbaasjes mist dit... en dat zorgt voor problemen
      </h1>

      <div className="flex items-center text-sm font-medium text-gray-500 mb-10 space-x-6" data-id="element-64">
        <div className="flex items-center" data-id="element-65">
          <User size={16} className="mr-2" data-id="element-66" />
          <span data-id="element-67">Door: Redactie</span>
        </div>
        <div className="flex items-center" data-id="element-68">
          <Clock size={16} className="mr-2" data-id="element-69" />
          <span data-id="element-70">5 minuten leestijd</span>
        </div>
      </div>

      <figure className="w-full mb-6" data-id="element-71">
        <div className="w-full aspect-[16/9] bg-gray-100 rounded-xl overflow-hidden relative shadow-sm" data-id="element-72">
          <img src="https://cdn.magicpatterns.com/uploads/sG8ZZqVoGpXRdEUcpgKXUQ/freepik__dog-subtly-signaling-his-female-owner-in-a-cozy-du__4932.jpg" alt="Hond die subtiel wegkijkt en signalen geeft" className="w-full h-full object-cover" data-id="element-73" />
        </div>
        <figcaption className="text-sm text-gray-500 mt-3 italic text-center" data-id="element-74">
          Honden communiceren constant met subtiele signalen die wij vaak
          missen.
        </figcaption>
      </figure>
    </section>;
}